import GraphemeSplitter from 'grapheme-splitter';
/**
 * 使用 `grapheme-splitter` 库的字符串适配器. 该适配器使用 `grapheme-splitter` 库将字符串转换为字符数组.
 *
 * 要使用 {@link GraphemeSplitterAdapter} 需要安装 `grapheme-splitter`.
 */
const GraphemeSplitterAdapter = () => {
    const splitter = new GraphemeSplitter();
    return {
        stringToChars(value) {
            return splitter.splitGraphemes(value);
        },
    };
};
export function register(counterAdapter) {
    counterAdapter.registerStringAdapter(['grapheme-splitter'], () => GraphemeSplitterAdapter());
}
export { GraphemeSplitterAdapter };
export default {
    register,
    GraphemeSplitterAdapter,
};
//# sourceMappingURL=grapheme-splitter.js.map